<div class="platform-shell">
  <nav class="navbar navbar-expand platform-navbar border-bottom px-4">
    <span class="navbar-brand mb-0">Essential<strong>Tickets</strong> · Plataforma</span>
    <div class="ms-auto d-flex align-items-center gap-3">
      <span class="text-muted small">{{ adminName }}</span>
      <button class="btn btn-sm btn-outline-secondary" (click)="logout()">Sair</button>
    </div>
  </nav>

  <div class="container-fluid py-4">
    <div class="header mb-4">
      <div class="header-body">
        <h6 class="header-pretitle">Onboarding</h6>
        <h1 class="header-title">Solicitações de acesso</h1>
      </div>
    </div>

    @if (lastInvite(); as invite) {
      <div class="card mb-4">
        <div class="card-body">
          <div class="d-flex align-items-start gap-3">
            <span class="avatar avatar-sm">
              <span class="avatar-title fs-lg rounded bg-success-soft text-success"><i class="fe fe-mail"></i></span>
            </span>
            <div class="flex-grow-1 min-w-0">
              <h4 class="mb-1">Convite de {{ invite.companyName }}</h4>
              <p class="text-muted small mb-3">
                Envie este link a {{ invite.adminEmail }} — é o que ativa o acesso. Enquanto não for usado,
                pode gerar um novo a qualquer momento na linha da solicitação.
              </p>
              <div class="input-group input-group-sm">
                <input class="form-control" type="text" readonly [value]="invite.inviteUrl" />
                <button class="btn btn-primary" type="button" (click)="copyInvite(invite.inviteUrl)">
                  <i class="fe fe-copy me-1"></i>{{ copied() ? 'Copiado!' : 'Copiar' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    @if (error()) {
      <div class="alert alert-danger">{{ error() }}</div>
    }

    <div class="card">
      <div class="card-body p-0">
        @if (loading()) {
          <p class="text-muted text-center py-5 mb-0">A carregar…</p>
        } @else if (requests().length === 0) {
          <p class="text-muted text-center py-5 mb-0">Nenhuma solicitação por aqui.</p>
        } @else {
          <div class="table-responsive">
            <table class="table table-hover table-nowrap card-table mb-0">
              <thead>
                <tr>
                  <th>Empresa</th><th>Contacto</th><th>E-mail</th><th>Situação</th><th class="text-end">Ações</th>
                </tr>
              </thead>
              <tbody>
                @for (req of requests(); track req.id) {
                  <tr>
                    <td>{{ req.companyName }}</td>
                    <td>{{ req.contactName }}</td>
                    <td>{{ req.email }}</td>
                    <td>
                      <span class="badge"
                        [class.bg-warning-soft]="req.status === 'PENDING'"
                        [class.bg-success-soft]="req.status === 'APPROVED'"
                        [class.bg-danger-soft]="req.status === 'REJECTED'">
                        {{ statusLabel(req.status) }}
                      </span>
                    </td>
                    <td class="text-end">
                      @if (req.status === 'PENDING') {
                        <button class="btn btn-sm btn-primary me-2" (click)="approve(req)">Aprovar</button>
                        <button class="btn btn-sm btn-outline-danger" (click)="reject(req)">Rejeitar</button>
                      } @else if (req.status === 'APPROVED') {
                        <button class="btn btn-sm btn-outline-secondary" (click)="resendInvite(req)">
                          <i class="fe fe-link me-1"></i>Gerar link de convite
                        </button>
                      } @else {
                        <span class="text-muted small">—</span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </div>
  </div>
</div>
